'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.HeadBanger = exports.setHeadBangerAdditionalTitle = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeadBangerAdditionalTitle = '';

var setHeadBangerAdditionalTitle = exports.setHeadBangerAdditionalTitle = function setHeadBangerAdditionalTitle(title) {
	HeadBangerAdditionalTitle = title;
};

var HeadBanger = exports.HeadBanger = function (_React$Component) {
	_inherits(HeadBanger, _React$Component);

	function HeadBanger() {
		_classCallCheck(this, HeadBanger);

		return _possibleConstructorReturn(this, (HeadBanger.__proto__ || Object.getPrototypeOf(HeadBanger)).apply(this, arguments));
	}

	_createClass(HeadBanger, [{
		key: 'getMetas',
		value: function getMetas() {
			var ret = {};
			var key = null;
			Object.values(document.getElementsByTagName('META')).map(function (meta) {
				key = null;
				if (meta.name !== '') {
					key = 'name_' + meta.name.toLowerCase();
				}
				if (meta.httpEquiv != null && meta.httpEquiv !== '') {
					key = 'http-equiv_' + meta.httpEquiv.toLowerCase();
				}
				if (meta.attributes.property != null && meta.attributes.property.nodeValue !== '') {
					key = 'property_' + meta.attributes.property.nodeValue.toLowerCase();
				}
				if (key != null) {
					ret[key] = meta;
				}
			});
			Object.values(document.getElementsByTagName('LINK')).map(function (link) {
				key = null;
				if (link.rel !== '') {
					var lrel = link.rel.toLowerCase();
					key = 'link_' + lrel;

					if (lrel === "alternate") {
						var lang = link.hreflang;
						key = key + '_' + lang;
					}
				}
				if (key != null) {
					ret[key] = link;
				}
			});
			return ret;
		}
	}, {
		key: 'createMeta',
		value: function createMeta() {
			var meta = document.createElement('meta');
			document.getElementsByTagName('head')[0].appendChild(meta);
			return meta;
		}
	}, {
		key: 'createLink',
		value: function createLink() {
			var link = document.createElement('link');
			document.getElementsByTagName('head')[0].appendChild(link);
			return link;
		}
	}, {
		key: 'createLanguageLink',
		value: function createLanguageLink() {
			var link = document.createElement('link');
			link.setAttribute("rel", "alternate");
			document.getElementsByTagName('head')[0].appendChild(link);
			return link;
		}
	}, {
		key: 'addLanguageToLink',
		value: function addLanguageToLink(link, lang) {
			var url = link.split("?")[0];
			var searchParams = link.split("?")[1] !== undefined ? link.split("?")[1] : "";

			var qs = _queryString2.default.parse(searchParams);
			qs.lang = lang.toLowerCase();
			searchParams = _queryString2.default.stringify(qs);

			return url + "?" + searchParams;
		}
	}, {
		key: 'setupLinks',
		value: function setupLinks(links, lang) {
			var _this2 = this;

			var langLinks = {};
			Object.entries(links).map(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    key = _ref2[0],
				    val = _ref2[1];

				langLinks[key] = _this2.addLanguageToLink(val, lang);
			});
			return langLinks;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props = this.props,
			    lang = _props.lang,
			    title = _props.title,
			    names = _props.names,
			    properties = _props.properties,
			    languages = _props.languages,
			    links = _props.links;

			var metas = this.getMetas();

			var linksSetup = links != null ? this.setupLinks(links, lang) : null;

			if (lang != null) {
				document.documentElement.setAttribute('lang', lang);
				if (metas['http-equiv_content-language'] != null) {
					metas['http-equiv_content-language'].setAttribute('content', lang);
				}
			}

			if (title != null) {
				document.title = title + " | " + HeadBangerAdditionalTitle;
			}

			if (names != null) {
				Object.entries(names).map(function (_ref3) {
					var _ref4 = _slicedToArray(_ref3, 2),
					    key = _ref4[0],
					    val = _ref4[1];

					val = val != null ? val : "";
					if (metas['name_' + key] == null) {
						metas['name_' + key] = _this3.createMeta();
						metas['name_' + key].setAttribute("name", key);
					}
					metas['name_' + key].setAttribute("content", val);
				});
			}
			if (properties != null) {
				Object.entries(properties).map(function (_ref5) {
					var _ref6 = _slicedToArray(_ref5, 2),
					    key = _ref6[0],
					    val = _ref6[1];

					val = val != null ? val : "";
					if (metas['property_' + key] == null) {
						metas['property_' + key] = _this3.createMeta();
						metas['property_' + key].setAttribute("property", key);
					}
					metas['property_' + key].setAttribute("content", val);
				});
			}
			if (linksSetup != null) {
				Object.entries(linksSetup).map(function (_ref7) {
					var _ref8 = _slicedToArray(_ref7, 2),
					    key = _ref8[0],
					    val = _ref8[1];

					val = val != null ? val : "";
					if (metas['link_' + key] == null) {
						metas['link_' + key] = _this3.createLink();
						metas['link_' + key].setAttribute("rel", key);
					}
					metas['link_' + key].setAttribute("href", val);
				});
			}
			if (languages != null) {
				Object.entries(languages).map(function (_ref9) {
					var _ref10 = _slicedToArray(_ref9, 2),
					    key = _ref10[0],
					    val = _ref10[1];

					var lc = val.toLowerCase();
					if (metas['link_alternate_' + lc] == null) {
						metas['link_alternate_' + lc] = _this3.createLanguageLink();
						metas['link_alternate_' + lc].setAttribute('hreflang', lc);
					}
					metas['link_alternate_' + lc].setAttribute("href", _this3.addLanguageToLink(linksSetup["canonical"], lc));
				});
			}
			return null;
		}
	}]);

	return HeadBanger;
}(_react2.default.Component);